export const constants = {
   VUE_APP_BASEURL: 'https://milehigh-api.dubois.ws/api',
  // VUE_APP_BASEURL: 'http://localhost:8000/api',

}
